var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sequence),function(item){return _c('div',{key:item.id},[_c('span',{style:(_vm.registercolor(item))},[_vm._v(_vm._s(item.mobile))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }